console.log("COPY 2")
$(document).ready(function() {
  function calculateTotals() {
    // Get the value from the input.count_quiz field
    var count_quiz_val = parseInt($('input.count_quiz').val()) || 0; // Default to 0 if no value
    var total = count_quiz_val; // Start total with count_quiz_val
    // Add up the values of all quantity inputs
    $('.quantityField.fileds_2.quantity_custom_class input[type="number"]').each(function() {
      total += parseInt($(this).val()); // Sum up all input values including button increments
    });
    // Log the total value for demonstration
    console.log('Total Quantity 12 (including count_quiz initial value): ' + total);
    // Display the total in the specified location, if necessary
    $('#total_quantity').text(total); // Assuming you have an element to display the total
   var quiz_val =  $('.quiz_val').val(total);  
  }  
//   $('#ProductSubmitButton-template--17197951025289__main').click(function(event) {
//     event.preventDefault();
//     window.location.href = '/pages/product-step-form'; 
// });
let currentStep = 0;
const totalSteps = $('.quiz-step').length;
// Set initial progress fill to 20% before any step
let initialProgress = 20;
$('#progress-fill').css('width', initialProgress + '%');
$('.next-btn').click(function() {
  var nextStep = $(this).data('next');
  var selectedValue = $('input[name="radio_field"]:checked').val();

  if (nextStep != "step4") {
    selectedValue = "Next"
  }
  if (selectedValue) {
    $('.quiz-step').addClass('hidden');
    // Conditional logic for custom steps
    if (selectedValue === 'Lebensmittelmotten') {
      $('#step4').removeClass('hidden');
    } else if (selectedValue === 'Kleidermotten') {
      $('#step7').removeClass('hidden');
    }
    else if (selectedValue === 'Beides') {
     // $('#step3_new').removeClass('hidden');
      var gt_id = $('button.next-btn.step-6').attr('data-id');
      // if(gt_id == 'add_shirt_fnnel'){
      //   $('button.step-6').addClass('new_funnel_steps');
      //     $('button.next-btn.step-6').removeClass('next-btn');
      //     $('button.step-6').removeClass('step-6');
      // }
    } else {
     console.log('hsdjksdhhhhhhjk');
      $('button.next-btn.step-6').click(function(){
       //$('.img_append').append('<img class="123_cls" src="https://cdn.shopify.com/s/files/1/0655/7453/5305/files/icons8-circle.gif?v=1726664039" alt="Loading..." id="loading-gif">');
        $('.img_append').css("display" , "block" , "!important");
      $('body.product-step-form.gradient.page').addClass('remove_popup');
     $('.popup-content').css("display" , "none" , "!important");

   });
      var nextStep = $(this).data('next');
      $('.quiz-step').addClass('hidden');
      $('#' + nextStep).removeClass('hidden');
    }

    // Add class to quantity fields in the next step
    $('#' + nextStep).find('.quantityField').each(function() {
      $(this).addClass('quantity_custom_class');
    });

    currentStep++;
    
    // Calculate progress including initial 20% fill
    console.log(currentStep);
    const totalSteps = 6;
    let progressPercentage = initialProgress + ((currentStep / totalSteps) * (100 - initialProgress));
    console.log(progressPercentage);
    $('#progress-fill').css('width', progressPercentage + '%');
  }
});

$('.quiz-step').each(function() {
    var step = $(this);
    step.find('input[type="radio"], input[type="checkbox"]').on('change', function() {
    if (step.find('input[type="radio"]:checked, input[type="checkbox"]:checked').length > 0) {
      step.find('.next-btn').removeClass('disabled').prop('disabled', false);
    } else {
      step.find('.next-btn').addClass('disabled').prop('disabled', true);
      }
        });
    });
    function checkQuantities() {
      let allValid = true;
    $('.quantity_custom_class input[type="number"]').each(function() {
      if ($(this).val() < 1) {
        allValid = false; 
      }
    });
    if (allValid) {
      $('.next-btn').removeClass('disabled').prop('disabled', false);
    } else {
        $('.next-btn').addClass('disabled').prop('disabled', true);
        }
    }
    $('.quantity_custom_class input[type="number"]').on('input', function() {
        checkQuantities(); 
    });
     $('button.step-9.next-btn.quiz-my-2').click(function(){
       //$('.img_append').append('<img class="new_mg" src="https://cdn.shopify.com/s/files/1/0655/7453/5305/files/icons8-circle.gif?v=1726664039" alt="Loading..." id="loading-gif">');
     $('.img_append').css("display" , "block" , "!important");
        $('body.product-step-form.gradient.page').addClass('remove_popup');
     $('.popup-content').css("display" , "none" , "!important");

   });
/*************************New Funnel Flow**********/
    $('.step-3').on('click', function(event) { 
      setTimeout(function(){
        $(".my_cls_cls_new").removeClass("hidden");
      },200);
    });
       $('button.step-4-new.next-btn').on('click', function(event) { 
          setTimeout(function(){
            $("div#step4").removeClass("hidden");
        },200);
      
    });
// $('input#q4a').on('click', function(event) { 
//     event.preventDefault();
//     console.log('dsdsds');
//     $('button.step-4-new.next-btns').removeClass('disabled').prop('disabled', false);  
// });


//    $('.Beides').on('click', function(event) {
//     get_current = $(this).attr('data-id');
//    if(get_current == 'Beides'){
//        $("button.next-btn.step-3").removeClass("next-btn ");
//         $("button.step-3").addClass("next-btns new_pgw");
//    }
// });
// $('button.step-3.disabled.next-btns.new_pgw').on('click', function(event) {

// });
setTimeout(function(){
  $('button#new_cls_funnale').removeClass('disabled');
},800);

$('.new_trigger').on('click', function(event) { 
   event.preventDefault();
//alert('hello');
setTimeout(function(){
  $('div#step3_new_second').removeClass('hidden');
 $('.my_cls_cls_new_second').removeClass('hidden');
},800);
 
  $('div#step6').css('display' ,'none');
});
$('button#new_cls_funnale').on('click', function(event) { 
   event.preventDefault();
//alert('dfjkhjdkfhdf');  
    $('#step7').removeClass('hidden');
 
});
$('button.new_trigger').on('click', function(event) { 
    event.preventDefault();
    console.log('dsdsds');
        $('button#new_cls_funnales').removeClass('disabled').prop('disabled', false); 
});
$('.Beides').on('click', function(event) {
    var $this = $(this); // Store reference to the clicked element
    setTimeout(function() {
        if ($this.hasClass('active')) {
            $('button.next-btn.step-6').css("display", "none");
            $('button.new_trigger').css("display", "block");
            $('.step-4-new .next-btn').removeClass('disabled').prop('disabled', false);
        }
    }, 300); // Adjust the timeout duration (1000 ms = 1 second) as needed
});
//    $('.Beides').on('click', function(event) { 
//     // $('.new_wrk').css("display" ,"block" , "!important");
//     // $('.old_wrk').css("display" ,"none" , "!important");
//     //event.preventDefault();
//     $('button.next-btn.step-6').css("display" , "none" , "!important");
//     $('button.new_trigger').css("display" , "block" , "!important");
//     $('.step-4-new .next-btn').removeClass('disabled').prop('disabled', false);
// });
$('button.new_trigger').click(function() {
     $('button#new_cls_funnale').removeClass('disabled').prop('disabled', false);

});
        // When clicking the increase button
  $('.increase').click(function() {
     // Get the input field in the same quantityField
    var input = $(this).siblings('input');
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
        input.val(currentVal + 1);  // Increase the value by 1
    } else {
      input.val(0);
    }
  });
   // When clicking the decrease button
  $('.decrease').click(function() {
    var get_count = $('input.count_quiz_new').val();
    if (!get_count) {
    // Disable the button and add 'disabled' class
    $('button.step-8.next-btn.quiz-my-1').addClass('disabled').prop('disabled', true);
    }
    var input = $(this).siblings('input');
      var currentVal = parseInt(input.val());
      if (!isNaN(currentVal) && currentVal > 0) {
        input.val(currentVal - 1);  // Decrease the value by 1 if it's greater than 0
      } else {
        input.val(0);  // Ensure the value doesn't go below 0
      }
  });
   let clickCount = 0;
   $("button.increase.first_calulation_1_new").click(function() {
     clickCount++;
     var get_count1 = $('input.count_quiz_new').val();
     if (get_count1 == 1) {
       // Enable the button and remove 'disabled' class
        $('button.step-8.next-btn.quiz-my-1').removeClass('disabled').prop('disabled', false);
    }
     var  get_count =    $("input.count_quiz_new").val(clickCount);
   });
   let clickCount1 = 0; 
    $("button.decrease.first_calulation_1_new").click(function() {
        console.log('Button clicked'); // Just for debugging
        clickCount1++; // Increment the click counter
        $("input.count_quiz_new").val(clickCount1);
        var get_count1 = $("input.count_quiz_new").val();
        console.log('Updated count: ', get_count1);
    });
   /*************************fresh Code***************/
   $('body').on('click', '.first_calulation_6', function() {
    var totalValue = 0;  // Initialize total to 0
    $('#step6 input[type="number"]').each(function(index){
        var inputValue = $(this).val();
        if (index === 0) {
            totalValue += inputValue * 2;  // First input value * 2
        } else if (index === 1) {
            totalValue += inputValue * 3;  // Second input value * 3
        }
    });
    setTimeout(function(){
        $('.step6_inputss').val(totalValue);  // Set the calculated totalValue
    }, 500);
});

let clickCount_quantity_getreide = parseInt($("#quantity_getreides").val(), 10) || 0; // Get initial value or 0
// Decrease button click
$("button.decrease.first_calulation_5").click(function() {
    if (clickCount_quantity_getreide > 0) { // Ensure value doesn't go below 0
        clickCount_quantity_getreide--;
    }
    // Update the input field value
    $("#quantity_getreides").val(clickCount_quantity_getreide);
    console.log(clickCount_quantity_getreide);
    // Get the updated value of the input
    var get_ccc = parseInt($("#quantity_getreides").val(), 10);
    console.log(get_ccc);
    // Enable or disable the next button based on the value
    if (get_ccc >= 1) {
        $('button.next-btn.step-5').removeClass('disabled').prop('disabled', false);
    } else {
        $('button.next-btn.step-5').addClass('disabled').prop('disabled', true);
    }
});
// Increase button click (assuming there's an increase button)
$("button.increase.first_calulation_5").click(function() {
    clickCount_quantity_getreide++; // Increment value
    // Update the input field value
    $("#quantity_getreides").val(clickCount_quantity_getreide);
    console.log(clickCount_quantity_getreide);
    // Get the updated value of the input
    var get_ccc = parseInt($("#quantity_getreides").val(), 10);
    console.log(get_ccc);
    // Enable or disable the next button based on the value
    if (get_ccc >= 1) {
        $('button.next-btn.step-5').removeClass('disabled').prop('disabled', false);
    } else {
        $('button.next-btn.step-5').addClass('disabled').prop('disabled', true);
    }
});
$('button.next-btn.step-6').click(function(){
   var url = window.location.href;
var urlParams = new URLSearchParams(window.location.search);
var steps = urlParams.get('steps');
   //alert(steps);
      var firstval = $("#quantity_getreides").val();
      var secondval = $('input.step6_inputss').val();
     // Convert both to numbers (if needed) and calculate the total
     var totalVal = Number(firstval) + Number(secondval);
    console.log(`${firstval} + ${secondval} = ${totalVal}`); // Output: 6 + 4 = 10
    console.log(totalVal);
    var baseUrl = 'https://anworlk.shop/pages/lebensmittelmotten-offer-v2';
  
    var url = baseUrl + '?quiz_total=' + encodeURIComponent(totalVal);
   window.location.href = url;
 // alert(url);
});
    $('button#new_cls_funnale').click(function(){
//alert('sdsd');
    
 var url = window.location.href;
var urlParams = new URLSearchParams(window.location.search);
var steps = urlParams.get('steps');
    if(steps == 'Beides'){
    $('div#step4').hide();
    }else{
       $('div#step4').show();
    }
    });
 $('button.step-9.next-btn.quiz-my-2').click(function(){
//alert('sdsd');
    
 var url = window.location.href;
var urlParams = new URLSearchParams(window.location.search);
var steps = urlParams.get('steps');
  // alert(steps,'kjhkjhjk');
    if(steps == 'Beides'){
      var firstval = $("#quantity_getreides").val();
      var secondval = $('input.step6_inputss').val();
     // Convert both to numbers (if needed) and calculate the total
     var totalVal = Number(firstval) + Number(secondval);
     var getVal1 = $('input.count_quiz_new').val();
     var getVal2 = $('input#quiz-my-new').val();
     console.log(getVal2);
     var totalValmyh = Number(getVal1) + Number(getVal2);
     console.log(totalValmyh, 'totalValmyh');
     var totalStatic = 3 + 2;
     console.log(totalStatic, 'totalStatic');
      //alert('Beides');
    var baseUrl = 'https://anworlk.shop/apps/alchemy/element/preview?elementId=c00e9a02-a943-4b99-974a-15d133b03bb7&storeId=89479508-c1c2-47ea-8760-5e0d90a6f748';
   var url = baseUrl + '&quiz_total=' + encodeURIComponent(totalVal) + '&result=' + encodeURIComponent(totalValmyh)+ '&steps=' + encodeURIComponent(steps);
   window.location.href = url;
    }
     if(steps == 'Kleidermotten'){
    // Get the value of the first input
    var getVal1 = $('input.count_quiz_new').val();
    console.log(getVal1);
    var getVal2 = $('input#quiz-my-new').val();
    console.log(getVal2);
    var totalValmyh = Number(getVal1) + Number(getVal2);
    console.log(totalValmyh, 'totalValmyh');
    //alert('Kleidermotten');
     var baseUrl = 'https://anworlk.shop/pages/kleidermotten-offer-v2';
    var url = baseUrl + '?quiz_total=' + encodeURIComponent(totalValmyh);
  window.location.href = url;
    }
});

/***********for multiple section******************/
  $('body').on('click', 'button.increase.first_calulation_1', function() {
    var totalValue1 = 0; // Start from 0 to accumulate the values
    $('#step8 input[type="number"]').each(function() {
      totalValue1 += Number($(this).val()) || 0; // Use 0 if the value is NaN
   });
    console.log(totalValue1); // Log the total value
    setTimeout(function() {
      $('.count_quiz_new').val(totalValue1); // Update count_quiz_new value
      var count_quiz_new = jQuery('input.count_quiz_new').val();
      if (count_quiz_new == '' || count_quiz_new == '0') {
        // Disable the button if count_quiz_new is empty or 0
        $('button.step-8.next-btn.quiz-my-1').addClass('disabled').prop('disabled', true);
        } else if (Number(count_quiz_new) >= 1) {
            // Enable the button if count_quiz_new is 1 or more
            $('button.step-8.next-btn.quiz-my-1').removeClass('disabled').prop('disabled', false);
        }
    }, 500);
});
$('body').on('click', 'button.decrease.first_calulation_1', function() {
  var totalValue12 = 0; // Start from 0 to accumulate the values
  $('#step8 input[type="number"]').each(function() {
    totalValue12 += Number($(this).val()) || 0; // Sum the values
  });
  console.log(totalValue12); // Log the total value
  setTimeout(function() {
    $('.count_quiz_new').val(totalValue12); // Update count_quiz_new value
    var count_quiz_new = jQuery('input.count_quiz_new').val();
    if (count_quiz_new == '' || count_quiz_new == '0') {
      // Disable the button if count_quiz_new is empty or 0
      $('button.step-8.next-btn.quiz-my-1').addClass('disabled').prop('disabled', true);
    } else if (Number(count_quiz_new) >= 1) {
      // Enable the button if count_quiz_new is 1 or more
      $('button.step-8.next-btn.quiz-my-1').removeClass('disabled').prop('disabled', false);
    }
  }, 500);
});

$('body').on('click', 'button.increase.first_calulation_2', function() {
  var totalValue1 = 0; // Start from 0 to accumulate the values
  $('#step9 input[type="number"]').each(function() {
  totalValue1 += Number($(this).val()) || 0; // Sum the values
});
  console.log(totalValue1); // Log the total value
  // Set a timeout to update the input field after 200 ms
  setTimeout(function() {
    $('input#quiz-my-new').val(totalValue1); // Set the totalValue
    var count_quiz_new = jQuery('input#quiz-my-new').val();
        if (count_quiz_new == '' || count_quiz_new == '0') {
            // Disable the button if count_quiz_new is empty or 0
            $('button.step-9.next-btn.quiz-my-2').addClass('disabled').prop('disabled', true);
        } else if (Number(count_quiz_new) >= 1) {
            // Enable the button if count_quiz_new is 1 or more
            $('button.step-9.next-btn.quiz-my-2').removeClass('disabled').prop('disabled', false);
        }
    }, 200);
});

$('body').on('click', 'button.decrease.first_calulation_2', function() {
    var totalValue1 = 0; // Start from 0 to accumulate the values
    $('#step9 input[type="number"]').each(function() {
        totalValue1 += Number($(this).val()) || 0; // Sum the values
    });
    console.log(totalValue1); // Log the total value
    // Set a timeout to update the input field after 500 ms
  setTimeout(function() {
    $('input#quiz-my-new').val(totalValue1); // Set the totalValue
    var count_quiz_new = jQuery('input#quiz-my-new').val();
    if (count_quiz_new == '' || count_quiz_new == '0') {
      // Disable the button if count_quiz_new is empty or 0
      $('button.step-9.next-btn.quiz-my-2').addClass('disabled').prop('disabled', true);
        } else if (Number(count_quiz_new) >= 1) {
            // Enable the button if count_quiz_new is 1 or more
            $('button.step-9.next-btn.quiz-my-2').removeClass('disabled').prop('disabled', false);
        }
    }, 500);
});

  $('#step3 input[type="radio"]').on('click', function() {
        $('#step3 input[type="radio"]').removeClass('active');
        $(this).addClass('active');
    });
   $('#step3 input[type="radio"]').on('click', function() {
    var steps = $(this).val();
    console.log(steps);
    var currentUrl = window.location.href;
    var url = new URL(currentUrl);
    url.searchParams.set('steps', steps);
    window.history.pushState({}, '', url);
    console.log(url.toString());
});

$('button.next-btn.step-3').click(function(){
console.log('sdsd');
  var url = window.location.href;
var urlParams = new URLSearchParams(window.location.search);
var steps = urlParams.get('steps');
    if(steps == 'Beides'){
        $('#step3_new').removeClass('hidden');
    }else{
        $('#step3_new').addClass('hidden');

    }

 
});
  
var url = window.location.href;
var urlParams = new URLSearchParams(window.location.search);
var steps = urlParams.get('steps');
  //  $('button.step-1.next-btn').click(function(){
  //     if(steps == 'Lebensmittelmotten'){
  //     $("div#progress-fill").css("width","39.1538%" ,"!important");
  //       }
  //   });
  //  $('button.step-2.next-btn').click(function(){
  //     if(steps == 'Lebensmittelmotten'){
  //     $("div#progress-fill").css("width","55.3077%" ,"!important");
  //       }
      
  //   });
  //   $('button.next-btn.step-3').click(function(){
  //     if(steps == 'Lebensmittelmotten'){
  //     $("div#progress-fill").css("width","71.4615%" ,"!important");
  //       }
  //      if(steps == 'Kleidermotten'){
  //     $("div#progress-fill").css("width","73.4615%" ,"!important");
  //       }
  //   });
  //  $('button.step-4.next-btn').click(function(){
  //    $("div#progress-fill").css("width","81.4615%" ,"!important");
  //     // if(steps == 'Lebensmittelmotten'){
  //     //   }
  //   });
  //    $('button.next-btn.step-5').click(function(){
  //     if(steps == 'Lebensmittelmotten'){
  //     $("div#progress-fill").css("width","90.4615%" ,"!important");
  //       }
  //   });
  //      $('button.next-btn.step-6').click(function(){
  //     if(steps == 'Lebensmittelmotten'){
  //     $("div#progress-fill").css("width","91.7692%" ,"!important");
  //       }
  //   });
  //     $('button.next-btn.step-7').click(function(){
  //     if(steps == 'Kleidermotten'){
  //     $("div#progress-fill").css("width","81.6154%" ,"!important");
  //       }
  //   });
  //   $('button.step-8.next-btn.quiz-my-1').click(function(){
  //     if(steps == 'Kleidermotten'){
  //     $("div#progress-fill").css("width","91.6154%" ,"!important");
  //       }
  //   });
      
});